/**
 * Created by Miguel on 23/05/2017
 */
import { Component, HostListener,OnInit, ViewChild,ChangeDetectionStrategy, ViewEncapsulation  } from '@angular/core';
import { ActivatedRoute,RouterLink} from '@angular/router';
import { DomSanitizer,  SafeResourceUrl , SafeHtml } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';
import { EventBean } from '../../beansts/Event';
import { CompanyService }  from '../../services/company.service';
import { AppDataService }  from '../../services/app-data.service';
import {CompanyBean} from "../../beansts/company.bean";
import {ItemBean} from "../../beansts/item.bean";

import { MessagingService } from "../../messaging.service";
import {Router} from "@angular/router";
import {FormBuilder, FormGroup} from "@angular/forms";
import {TranslationService} from '../../services/translation.service';
import {EventComponent} from './event.component'
import { WalletService }  from '../../services/wallet.services';
//teleview
declare var Swal : any;
declare var $ : any;
@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    selector : 'speakerRoom',
    templateUrl:'speaker.room.component.html',
    providers  : []
})
export class SpeakerRoomComponent extends EventComponent implements OnInit {

    private _companiesSubscription : Subscription;
    public event: EventBean=new EventBean();
    public buyerGold=0

    public photo='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/gameImages%2Fbackgrounds%2Ftela%20fundo%20reuniao.jpeg?alt=media&token=2303f2d4-4b37-4531-aca0-c26b489a5465'
    public muted;

    public room
    public roomVideo=""
    public door;
    public iframeVolume;
    public queryRoom=null;

    public speaker;
    public user={uid:'n/a',full_name:'Anonimo',profile_picture:'nil'};
    public userOnView;
    public openContact=false;
    public chatId;
    public loginTab=false;
    public tables=[];
    public notification;
    public hasTele=false;
    public mytable={};
    public countdown='';

    public zoomControl=0;
    public old=false;

    public partyMembersRef;
    public conference=true;
    public loadingConference=false;
    public hasCamera=true;
    public bigConference=false;
    public bigStream=false;
    public videoCall='';

    public admin= false;
    public video='DESLIGAR VIDEO'

    public changed=null;
    public loveList=[];
    public userList=[];
    public enterOrAvatar="ENTRAR"


    public eventStarts=0;

    public toggleCellPhone=false;
    public nameTable=true;
    public chooseFriends=false;

    public language="pt"
    public notificationsON=false;
    public tab=1;

    public canEdit;

    public companyEvents:EventBean [];
    public company:CompanyBean=new CompanyBean();
    public meetingForm

    constructor( public _sanitizer: DomSanitizer,public translate: TranslationService, public _router : Router,public _routeParams : ActivatedRoute,public _companyService : CompanyService,public _walletService : WalletService, public _appData : AppDataService,public msgService: MessagingService, public fb: FormBuilder) {
      super( _sanitizer, translate, _router,_routeParams, _companyService,_walletService,  _appData,msgService,null)
      this.meetingForm = this.fb.group({
        name : '',
        objective : '',
        locked: '',
      });
    }
    public ngOnDestroy() {

    }

    @HostListener('document:keydown', ['$event'])
    keypress(e: KeyboardEvent) {
      if (e.keyCode == 38) {
        this.zoom(true)
        // up arrow
      }
      else if (e.keyCode == 40) {
          // down arrow
          this.zoom(false)
      }

    }

    public gotoMetaverse(){
      let sent=false;
      let length=this.speaker.rooms.length;
      let testes=0
      this.speaker.rooms.forEach(v=>{
        this._companyService.getUserRoomPosition(v.id).get().then((snap)=>{
          snap.forEach(val=>{
            let us=val.data(); //objects correspond to users;
            let tusers=0;
            testes=testes+1;
            if (us){
              tusers=Object.keys(us).length;
            }
            else{
              tusers=0;
            }
            if (tusers<v.roomLimit){
              sent=true;
              let domain=window.location.origin
              window.location.href=domain+"/welcome?event="+this._appData.event.id+'&room='+v.id;     
            }
            if ((testes==length) && !sent){
              Swal.fire({title:'Todas as salas estão ocupadas',text:'Infelizmente todas as salas estão em seu limite de usuários. Aguarde para tentar de novo. Por enquanto aproveite a mídia do evento.'})
            }
  
          })
  
      })
  
    })
  
  
      
    }
    public getLink(){
      let domain=window.location.origin
      navigator.clipboard.writeText(domain+'/speakerroom/'+this._appData.event.id+'?evt='+this.appEvent+'&speaker='+this.appSpeaker)
      Swal.fire(this.translate.instant('SUCCESS'),'Link da sala transferido para memória. Use Ctrl-V para colar o link em conversa com quem você quiser convidar.')
    }
    public ngOnInit() : any {
      super.ngOnInit();      
      this._appData.page='speakerroom'
      if (this.appSpeaker){
        this._companyService.getEventOnApp().doc(this.appSpeaker).get().then(val=>{
          this.speaker=val.data();
          this.room=this.speaker.rooms[0]
          this._appData.room=this.room
          $("#chatReload").click();

          let date= new Date();
          let milis=date.getTime();
          if (milis>this.speaker.start){
            this.old=true;
          }
          this._companyService.getRoom(this.room.id).onSnapshot((v) => {
            this.room=v.data()
            this.roomVideo=this.room.video;
            
          })
        })
      
        this._companyService.getEventOnApp().doc(this.appEvent).get().then(val=>{
          this._appData.dashboardEvent=val.data();
          $('#dashboardContent').css('background-color',this._appData.dashboardEvent.color)
        })


      if (this._appData.instagramUser){
        this._walletService.getTokenBalance('user',this._appData.instagramUser.uid).subscribe(val=>{
          let vet=val.json();
          let lid=1;
          vet.forEach(element => {
            let address=element.mint_address
            let amount=element.ui_amount
            if (address=='BmHvLKAGRd2o3WKm2U7u7qaJoAjzqCQfzLyUVrFznmuu'){
              this.buyerGold=amount;
            }
          })
        })
  
      }


      setInterval(()=>{
        let date= new Date();
        let milis=date.getTime();
        if (milis>this.speaker.start){
          this.old=true;
        }
      },10000)
      }
  }

  public addToCalendar(){
    this._companyService.getCalendar(this._appData.instagramUser.uid).doc(this.speaker.id).set(this.speaker);
    Swal.fire({title:'Atividade adicionada',text:'Atividade adicionada com sucesso na sua agenda. Veja no seu celular'})
    this._appData.cellScreen="calendar"
    this._appData.toggleCellPhone=true

  }

  public onChangeForm(){
    this.meetingForm = this.fb.group({
      name :  this._appData.room.meetingName,
      objective : this._appData.room.meetingObjective,
      locked: this._appData.room.locked,
    });
  }

  public changeRoom(){
    let date=new Date();
    let time=date.getTime();
    let name=this.meetingForm.controls['name'].value;
    let objective=this.meetingForm.controls['objective'].value;
    let lock=this.meetingForm.controls['locked'].value;
    if (!lock) lock=false;
    let notification={
      event:this._appData.event.id,
      time:time,
      senderUid:this._appData.instagramUser.uid,
      senderName:name,
      senderThumbnail:'',
      subject:name,
      message:objective,
      kind:'roomChange',
      link:lock,
      read:false,
      action:'',
      answer:''
    }
    this._companyService.addRoomNotification(this._appData.room,notification)
    Swal.fire({title:'Mudanças feitas',text:'Atualizados dados da sala'})
  }
  private lockedRoomControl(){


   // if (this._appData.instagramUser.uid>0){
      if (this._appData.userEventContainer){
        this.popUpLockedRoom();
      }
      else{
        this._companyService.getUserContainerRef().get().then(cdata=>{
          let clist=[];
  
          cdata.forEach(c=>{
            let item=new ItemBean();
            item.parse(c.data())
            clist.push(item)
          })
          this._appData.userEventContainer=clist;
          this.popUpLockedRoom();
        })
      }

  }
  public popUpLockedRoom(){
    let key=this._appData.room.key;
    let hasKey=this.checkKey(key);
 
    
      if (!this._appData.instagramUser.full_name){
        Swal.fire({title:"Sala trancada",
          text: 'Esta sala de reuniões está trancada. Por favor escreva o seu nome e clique ok para pedir autorização aos presentes na sala para entrar.',
          input: 'text',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: 'Salvar',
          showLoaderOnConfirm: true,
          preConfirm: (name) => {
            let date=new Date();
            let time=date.getTime();
            let notification={
              event:this._appData.event.id,
              time:time,
              senderUid:this._appData.instagramUser.uid,
              senderName:name,
              senderThumbnail:'',
              subject:'Knock Knock',
              message:name+' deseja entrar na sala. Você permite ele entrar?',
              kind:'enterRoom',
              link:'',
              read:false,
              action:'',
              answer:''
            }
            this._companyService.addRoomNotification(this._appData.room,notification)
          }
        })
      }
      else if (hasKey){
        Swal.fire({title:"Sala trancada",
          text: 'Esta sala de reuniões está trancada. Você possui a chave...deseja entrar de qualquer forma?',
          showCancelButton: true,
          confirmButtonText: 'ENTRAR',
          showLoaderOnConfirm: true,
          preConfirm: (name) => {
            if (name){
              $("#jitsiReload").click();   
              this.canEdit=true;
            }
          }
        })
      }
      else{
        var swalObj={
          title: "Sala trancada",
          showCloseButton: true,
          text: "Esta sala de reuniões está trancada. Você deseja pedir autorização aos presentes na sala para entrar?",
          showConfirmButton:true,
          confirmButtonText:'Sim'
        }
        Swal.fire(swalObj).then( (resultok) =>{
            if (resultok.value) {
              let name=this._appData.instagramUser.full_name
              let date=new Date();
              let time=date.getTime();
              let notification={
                event:this._appData.event.id,
                time:time,
                senderUid:this._appData.instagramUser.uid,
                senderName:name,
                senderThumbnail:'',
                subject:'Knock Knock',
                message:name+' deseja entrar na sala. Você permite ele entrar?',
                kind:'enterRoom',
                link:'',
                read:false,
                action:'',
                answer:''
              }
            this._companyService.addRoomNotification(this._appData.room,notification)
            }
        });         
      }




  }


  private logUserToRoom(){

          if (this._appData.room.locked){
            this.lockedRoomControl()
          }
          else{
            this.addToParty();
            $("#jitsiReload").click();   
            this.canEdit=true;          }
         
/*
       this._companyService.getUserRefOnRoom(this._appData.room.id+'/'+this._appData.instagramUser.uid).set({full_name:this._appData.instagramUser.full_name,profile_picture:this._appData.instagramUser.profile_picture,uid:this._appData.instagramUser.uid,volume:-1})
       $(window).bind('beforeunload',  () =>{
            let keys=Object.keys(this._appData.userLookup).length
            if (keys<=1){
              this._appData.userLookup={}
              this._companyService.updateConferenceUsers(this._appData.room).set(this._appData.userLookup).then(()=>{
              })
            }
       });*/
    }

    public notifyRegister(){
      let date=new Date();
      let time=date.getTime();
      let name=this._appData.instagramUser.full_name;
      let notification={
        event:this._appData.event.id,
        time:time,
        senderUid:this._appData.instagramUser.uid,
        senderName:name,
        senderThumbnail:'',
        subject:'Pedido de cadastro',
        message:'Você deseja se cadastar?',
        kind:'registerNotification',
        link:'',
        read:false,
        action:'',
        answer:''
      }
      this._companyService.addRoomNotification(this._appData.room,notification) 
    }
    public notifyAvatar(){
      let date=new Date();
      let time=date.getTime();
      let name=this._appData.instagramUser.full_name;
      let notification={
        event:this._appData.event.id,
        time:time,
        senderUid:this._appData.instagramUser.uid,
        senderName:name,
        senderThumbnail:'',
        subject:'Mudar Avatar',
        message:'Você deseja mudar seu avatar?',
        kind:'avatarChange',
        link:'',
        read:false,
        action:'',
        answer:''
      }
      this._companyService.addRoomNotification(this._appData.room,notification)   
    }
    public cameraFix(){
      let date=new Date();
      let time=date.getTime();
      let name=this._appData.instagramUser.full_name;
      let notification={
        event:this._appData.event.id,
        time:time,
        senderUid:this._appData.instagramUser.uid,
        senderName:name,
        senderThumbnail:'',
        subject:'Pedido de fix camera',
        message:'Pede para voce autorizar mudar a camera',
        kind:'cameraFix',
        link:'',
        read:false,
        action:'',
        answer:''
      }
      this._companyService.addRoomNotification(this._appData.room,notification) 
    }

    public checkKey(needKey){
      if (needKey==this._appData.instagramUser.uid){
        return true;
      }
      else{
        let filtered=this._appData.userEventContainer.filter(val=>{
          return val.name==needKey                 
        })
        if (filtered[0]){
          return true;
        } 
      }
      return false;
    }
    private checkCookie(){
      var cookieEnabled = navigator.cookieEnabled;
      if (!cookieEnabled){ 
          document.cookie = "testcookie";
          cookieEnabled = document.cookie.indexOf("testcookie")!=-1;
      }
      return cookieEnabled || this.showCookieFail();
    }
  
    public toggleLoginTab(tab){
      if (!this._appData.instagramUser){
        this.loginTab=tab;
      }
    }
    private showCookieFail(){
    // do something here
    Swal.fire('Browser sem cookies','Precisamos que você habilite os cookies para podermos fazer o cadastro na lista')
    return false;
    }


    public gotoCell(){
      if (isNaN(this._appData.instagramUser.uid)){
        this._appData.toggleCellPhone=!this._appData.toggleCellPhone;
      }
      else{
        $('#registerSocialModal').modal("show"); 
      }

    }


public enter(){
  if (!this._appData.instagramUser){
    if (this.event.private){
      $('#registerSocialModal').modal("show"); 
    }
    else{
      $('#privatePartyModal').modal("show"); 
    }
  }
}

public getImageNoDraw(imgRef) {
  if (this._appData.images[imgRef])
      return this._appData.images[imgRef];
  else {
      // Load image if not in cache
      var img = new Image();
      img.src = imgRef;
      img.onload = ()=>{
        this._appData.images[imgRef].loaded=true;
      }
      this._appData.images[imgRef] = img;
      return img;
  }
}


    public gotoMyData(){
      $('#jitsi-control-tutorial').click();

      $('#updateMeModal').modal('hide');
      this._router.navigate(['/userprofile'])
      this._companyService.getUserContainer(true)
    }





  public zoom(inout){



    if (inout){
//      if (this.zoomControl<20){
        this.zoomControl=this.zoomControl+1;
        this.sendIframeMessage({kind:'zoomout'})
        $("#btnZoomIn").attr("src", "./assets/game-ui/desk/g6501.png");
        setTimeout(()=>{
          $("#btnZoomIn").attr("src", "./assets/game-ui/desk/g4421.png");
        },1000);
  //    }
    }
    else{
    //  if (this.zoomControl>-8){
        this.zoomControl=this.zoomControl-1;
        this.sendIframeMessage({kind:'zoomin'})
        $("#btnZoomOut").attr("src", "./assets/game-ui/desk/g6631.png");
        setTimeout(()=>{
          $("#btnZoomOut").attr("src", "./assets/game-ui/desk/g4415.png");
        },1000);
  
      //}
      

    }
  }
  public sendIframeMessage(messageKind){
      var iframe = document.getElementById('gameFrame');
      if (iframe == null) return;
      var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
      iWindow.postMessage(messageKind, "*");
  }



  public leave(){
    Swal.fire({
      title: 'Sair',
      message:' Você deseja sair desta atividade?',
      confirmButtonText: 'Sair',
      cancelButtonText:"Ficar",
      showCancelButton: true,
      focusConfirm: false,}).then((result) => {
        if (result.dismiss=='backdrop') {}
        else if (result.dismiss=='cancel'){
          //sair
        }
        else if (result.value) {
          //entrar
          //entrar
          let domain=window.location.origin
         window.location.href = domain+"/eventdashboard/"+this._appData.event.id+"?evt="+this.appEvent;
        }
      })

  }
  public addItem(){

    let livecoin=this.buyerGold;
    let date=new Date();
    let milis=date.getTime()
    Swal.fire({
      title: 'Que item deseja comprar?',
      html: "<img id='postitImg"+milis+"' src='/assets/game-ui/desk/g31611.png' style='width:50px;height:50px'><img id='docs"+milis+"' src='/assets/game-ui/desk/g31611B.png' style='width:50px;height:50px;margin-left:5px'><img id='excel"+milis+"'  src='/assets/game-ui/desk/g31611C.png' style='width:50px;height:50px;margin-left:5px'><img id='powerpoint"+milis+"' src='/assets/game-ui/desk/g31611D.png' style='width:50px;height:50px;margin-left:5px'><img id='draw"+milis+"' src='/assets/game-ui/desk/g31611E.png' style='width:50px;height:50px;margin-left:5px'>",
      showConfirmButton: false,
      showCancelButton: false,     
    })
    $(document).on('click', '#postitImg'+milis, ()=> {
      let cost=1;
      if (livecoin>cost){
        Swal.fire({
          title:'Comprar Postits',
          text:'Os postits servem para você conectar qualquer link externo e compartilhar com pessoas. Cada 10 postits custam 1 LiveCoin. Você possui '+livecoin+' livecoins em sua wallet. Deseja comprar os 10 postits?',     
          confirmButtonText: "Sim",
          cancelButtonText:"Não",
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false, 
          }).then((result) => {
            if (result.dismiss=='backdrop') {}
            else if (result.dismiss=='close') {}
            else if (result.dismiss=='cancel'){}
            else{
              this.makePostIt();
            }           
        }) 
      }
      else{
        Swal.fire({
          title:'Comprar Postits',
          text:'Os postits servem para você conectar qualquer link externo e compartilhar com pessoas. Cada 10 postits custam 1 LiveCoin. Você possui '+livecoin+' livecoins em sua wallet. Você deseja comprar mais LiveCoins?',     
          confirmButtonText: "Sim",
          cancelButtonText:"Não",
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false, 
          }).then((result) => {
            if (result.dismiss=='backdrop') {}
            else if (result.dismiss=='close') {}
            else if (result.dismiss=='cancel'){}
            else{
              Swal.fire({title:'Aguarde',text:'Essa função está em desenvolvimento. Em breve você poderá comprar livecoins aqui.'})
            }           
        }) 
      }

    }); 
    $(document).on('click', '#docs'+milis, ()=> {
      //1639442415373 livro
      let cost=1;
      if (livecoin>cost){
        Swal.fire({
          title:'Comprar Livro',
          text:'O Livro é um documento do tipo GOOGLE DOC preparado para uso. Você pode escrever e compartilhar com pessoas. Cada livro custa 1 LiveCoin. Você possui '+livecoin+' livecoins em sua wallet. Deseja comprar os 1 livro?',     
          confirmButtonText: "Sim",
          cancelButtonText:"Não",
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false, 
          }).then((result) => {
            if (result.dismiss=='backdrop') {}
            else if (result.dismiss=='close') {}
            else if (result.dismiss=='cancel'){}
            else{
              this.makeItem('application/vnd.google-apps.document','1639442415373')
            }           
        }) 
      }
      else{
        Swal.fire({
          title:'Comprar Livro',
          text:'O Livro é um documento do tipo GOOGLE DOC preparado para uso. Você pode escrever e compartilhar com pessoas. Cada livro custa 1 LiveCoin. Você possui '+livecoin+' livecoins em sua wallet. Deseja adquirir mais livecoins?',     
          confirmButtonText: "Sim",
          cancelButtonText:"Não",
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false, 
          }).then((result) => {
            if (result.dismiss=='backdrop') {}
            else if (result.dismiss=='close') {}
            else if (result.dismiss=='cancel'){}
            else{
              Swal.fire({title:'Aguarde',text:'Essa função está em desenvolvimento. Em breve você poderá comprar livecoins aqui.'})
            }           
        }) 
      }

    }); 
    $(document).on('click', '#excel'+milis, ()=> {
      //1639448112414 excel
      let cost=1;
      if (livecoin>cost){
        Swal.fire({
          title:'Comprar Calculadora',
          text:'A calculadora é um documento do tipo GOOGLE EXCEL preparado para uso. Você pode escrever e compartilhar com pessoas. Cada calculadora custa 1 LiveCoin. Você possui '+livecoin+' livecoins em sua wallet. Deseja comprar os 1 calculadora?',     
          confirmButtonText: "Sim",
          cancelButtonText:"Não",
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false, 
          }).then((result) => {
            if (result.dismiss=='backdrop') {}
            else if (result.dismiss=='close') {}
            else if (result.dismiss=='cancel'){}
            else{
              this.makeItem('application/vnd.google-apps.spreadsheet','1639448112414')
            }           
        }) 
      }
      else{
        Swal.fire({
          title:'Comprar Calculadora',
          text:'A calculadora é um documento do tipo GOOGLE EXCEL preparado para uso. Você pode escrever e compartilhar com pessoas. Cada calculadora custa 1 LiveCoin. Você possui '+livecoin+' livecoins em sua wallet. Deseja comprar LIVECOINS?',     
          confirmButtonText: "Sim",
          cancelButtonText:"Não",
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false, 
          }).then((result) => {
            if (result.dismiss=='backdrop') {}
            else if (result.dismiss=='close') {}
            else if (result.dismiss=='cancel'){}
            else{
              Swal.fire({title:'Aguarde',text:'Essa função está em desenvolvimento. Em breve você poderá comprar livecoins aqui.'})
            }           
        })
      } 
    }); 
    $(document).on('click', '#powerpoint'+milis, ()=> {
      //1639448539824 cavelete
      let cost=1;
      if (livecoin>cost){
        Swal.fire({
          title:'Comprar Cavalete',
          text:'O Cavalete é um documento do tipo GOOGLE POWERPOINT preparado para uso. Você pode escrever e compartilhar com pessoas. Cada cavalete custa 1 LiveCoin. Você possui '+livecoin+' livecoins em sua wallet. Deseja comprar o cavalete?',     
          confirmButtonText: "Sim",
          cancelButtonText:"Não",
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false, 
          }).then((result) => {
            if (result.dismiss=='backdrop') {}
            else if (result.dismiss=='close') {}
            else if (result.dismiss=='cancel'){}
            else{
              this.makeItem('application/vnd.google-apps.presentation','1639448539824')
            }           
        }) 
      }
      else{
        Swal.fire({
          title:'Comprar Cavalete',
          text:'O Cavalete é um documento do tipo GOOGLE POWERPOINT preparado para uso. Você pode escrever e compartilhar com pessoas. Cada cavalete custa 1 LiveCoin. Você possui '+livecoin+' livecoins em sua wallet. Deseja comprar LIVECOINS?',     
          confirmButtonText: "Sim",
          cancelButtonText:"Não",
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false, 
          }).then((result) => {
            if (result.dismiss=='backdrop') {}
            else if (result.dismiss=='close') {}
            else if (result.dismiss=='cancel'){}
            else{
              Swal.fire({title:'Aguarde',text:'Essa função está em desenvolvimento. Em breve você poderá comprar livecoins aqui.'})
            }           
        })
      }       
    }); 
    $(document).on('click', '#draw'+milis, ()=> {
      //1639448539824 cavelete
            //1639448112414 excel
            let cost=1;
            if (livecoin>cost){
              Swal.fire({
                title:'Comprar Cavalete',
                text:'O Cavalete é um documento do tipo GOOGLE DESENHO preparado para uso. Você pode desenhar e compartilhar com pessoas. Cada cavalete custa 1 LiveCoin. Você possui '+livecoin+' livecoins em sua wallet. Deseja comprar o cavalete?',     
                confirmButtonText: "Sim",
                cancelButtonText:"Não",
                showCloseButton: true,
                showCancelButton: true,
                focusConfirm: false, 
                }).then((result) => {
                  if (result.dismiss=='backdrop') {}
                  else if (result.dismiss=='close') {}
                  else if (result.dismiss=='cancel'){}
                  else{
                    this.makeItem('application/vnd.google-apps.drawing','1639448539824')
                  }           
              }) 
            }
            else{
              Swal.fire({
                title:'Comprar Cavalete',
                text:'O Cavalete é um documento do tipo GOOGLE DESENHO preparado para uso. Você pode desenhar e compartilhar com pessoas. Cada cavalete custa 1 LiveCoin. Você possui '+livecoin+' livecoins em sua wallet. Deseja comprar LIVECOINS?',     
                confirmButtonText: "Sim",
                cancelButtonText:"Não",
                showCloseButton: true,
                showCancelButton: true,
                focusConfirm: false, 
                }).then((result) => {
                  if (result.dismiss=='backdrop') {}
                  else if (result.dismiss=='close') {}
                  else if (result.dismiss=='cancel'){}
                  else{
                    Swal.fire({title:'Aguarde',text:'Essa função está em desenvolvimento. Em breve você poderá comprar livecoins aqui.'})
                  }           
              })
            }       
      
    }); 


        


  }
  public makePostIt(){
    let date=new Date();
    let milis=date.getTime()
    let vet=this._appData.eventRecipes.filter(v=>{
      return v.id=='POSTIT'
    })
    let rec=vet[0]
    let baseItem=rec.toItem()
    baseItem.objectId=milis.toString();
    baseItem.position.x=10
    baseItem.position.y=10
    baseItem.position.z=0
    Swal.fire({
      title: 'Transferindo',
      text: 'Aguarde enquanto a receita do item esta sendo criada',
      imageUrl: "https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/gameImages%2Ftransfer.gif?alt=media&token=67c0bdef-76b4-40e5-8fdb-65501ef94aff",
      showConfirmButton: false
    })
    this._walletService.makePurchaseTransfer(this._appData.event.id,'event',this._appData.instagramUser.uid,'user',rec.tokenId,10,baseItem.toDB(),null,null,this._appData.instagramUser.uid,'user-container',1).subscribe(wa=>{
      Swal.close()
      this._companyService.getUserContainer(true);
      Swal.fire(this.translate.instant('SUCCESS'),'Seus items foram criados e estão disponíveis para uso na sua mochila')
    },err=>{
      Swal.close()
      Swal.fire(this.translate.instant('FAIL'),'Ouve uma falha na criação do token para sua carteira. Tente de novo')

    }) 
  }
  public makeItem(type,recipeId){
          //entrar
          Swal.fire({
            title: 'Selecione o nome do arquivo',
            input: 'text',
            inputAttributes: {
              autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Salvar',
            showLoaderOnConfirm: true,
            preConfirm: (login) => {
              if (!login){
                Swal.fire('Erro..','Selecione um nome pro arquivo')
              }
              else{
                let fileName=login;
                Swal.fire({
                  title: 'Criando seu arquivo',
                  html: 'Estamos criando seu arquivo. Isso pode demorar um pouco então por favor pedimos que você aguarde com o browser ligado. Ao final do processo o seu arquivo vai aparecer na área de trabalho.',
                })
                let vet=this._appData.eventRecipes.filter(v=>{
                  return v.id==recipeId
                })
                let rec=vet[0]
                let baseItem=rec.toItem()
                baseItem.name=fileName;
                baseItem.position.x=10
                baseItem.position.y=10
                baseItem.position.z=0
                Swal.fire({
                  title: 'Transferindo',
                  text: 'Aguarde enquanto a receita do item esta sendo criada',
                  imageUrl: "https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/gameImages%2Ftransfer.gif?alt=media&token=67c0bdef-76b4-40e5-8fdb-65501ef94aff",
                  showConfirmButton: false
                })
                this._walletService.makePurchaseTransfer(this._appData.event.id,'event',this._appData.instagramUser.uid,'user',rec.tokenId,1,baseItem.toDB(),null,null,this._appData.instagramUser.uid,'user-container',1).subscribe(wa=>{
                  this._companyService.addNewFileToDrive(this._appData.instagramUser.uid,type,fileName).then(
                    (val)=>{
                      baseItem['param']={link:val,name:fileName},
                      this._companyService.getUserContainerRef().doc(baseItem.objectId).set(baseItem.toDB()).then(val=>{
                        Swal.close()
                        this._appData.userEventContainer.push(baseItem);
                        Swal.fire(this.translate.instant('SUCCESS'),'Seu item foi criado e está disponível para uso em sua mochila')
                      }); 

                  }); 
                },err=>{
                  Swal.close()
                  Swal.fire(this.translate.instant('FAIL'),'Ouve uma falha na criação do token para sua carteira. Tente de novo')

                })
    
              }
            }
          })
  }
  public gotoBag(){
   // if (isNaN(this._appData.instagramUser.uid)){
      this._appData.object=null;
      $('#jitsi-control-tutorial').click();
      $('#containerModal').modal('show')
      $('#containerModal').draggable({
        handle: ".modal-header"
      });
      $('#containerModalClick').click(); 
  //  }
//    else{
   //   Swal.fire('Você está deslogado','Você precisa estar logado para acessar sua mochila.')
 //   }
  }
  public openVideoConf(){
    this.sendIframeMessage({
      kind:'toggleJitsi',
      params:true
    });      
    this._appData.jitsiOn=true;   
    $("#media-control").css("visibility", "hidden");
    $("#youtubeScreen").css("left", "200vw");
    $("#media-control-mobile").css("visibility", "hidden");
    $("#youtubeMobileScreen").css("left", "200vw");      
    $("#videoMobileImage").css('visibility','hidden');
    $("#videoMobileImage2").css('visibility','hidden');
    $("#videoMobileImage3").css('visibility','hidden');
    $("#videoImage1").css('visibility','hidden');
    $("#videoImage2").css('visibility','hidden');
    $("#videoImage3").css('visibility','hidden');
    $("#videoImage4").css('visibility','hidden');

  }
  public openContacts(){


    
    $('#jitsi-control-tutorial').click();
    if (isNaN(this._appData.instagramUser.uid)){
      let idx=$("#profileModal")
      idx.modal('show');
    }
    else{
      $('#registerSocialModal').modal('show')
    }
  }

  public closeModal(name){
    $('#'+name).modal('hide');
    this.nameTable=false;
    this.chooseFriends=false;

  }






  public camera(on: boolean){
        this.videoCall=null;
        if (on != this._appData.conference){
          this.conference=on;
          this._appData.conference=this.conference;
          $('#jitsiReload').click()
          
          $("#chatReload").click();   
          if (!this.conference){
            Swal.fire({title:this.translate.instant('NO_CAMERA_TITLE'),text:this.translate.instant('NO_CAMERA_DESCRIPTION')})
          }
  
        }
  }








}





// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/speaker.room.component.ts